import { makeStyles } from "@material-ui/core";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#fff",
    position: "relative",
    // height: "100vh",
    "@media(max-width:1280px)": {
      height: "auto !important",
    },
  },
  MainLayout: {
    height: "100vh",
    overflowX: "hidden",
  },

  footerSec: {
    position: "absolute",
    bottom: "0px",
    left: "0px",
    right: "0px",
  },
}));

const PageNotfound = ({ children }) => {
  const classes = useStyles();
  const location = useLocation();

  return (
    <div className={classes.root}>
      <div
        style={
          location.pathname !== "/" ? { display: "block" } : { display: "none" }
        }
      ></div>
      <div className={classes.MainLayout}>{children}</div>
    </div>
  );
};

export default PageNotfound;
